// extracted by mini-css-extract-plugin
export var address = "OfficePopup-module--address--8928d";
export var button = "OfficePopup-module--button--c629f";
export var closeButton = "OfficePopup-module--closeButton--8e42c";
export var content = "OfficePopup-module--content--09c8e";
export var fadeInAnimation = "OfficePopup-module--fadeInAnimation--3131b";
export var gallery = "OfficePopup-module--gallery--5b29f";
export var hideImagesCount = "OfficePopup-module--hideImagesCount--0f33b";
export var img = "OfficePopup-module--img--3bfde";
export var imgWrapper = "OfficePopup-module--imgWrapper--e4d37";
export var phone = "OfficePopup-module--phone--a5fa0";
export var title = "OfficePopup-module--title--d50d2";
export var wide = "OfficePopup-module--wide--f6cd1";
export var wrapper = "OfficePopup-module--wrapper--af16e";